module.exports = __webpack_public_path__ + "images/favicon-96x96-35eaa17d4566813efe3e0252c72ae0d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicons/favicon-96x96.png
// module id = ./src/images/favicons/favicon-96x96.png
// module chunks = 1